import { LoadingButton } from '@mui/lab';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import { ADD_USER_ROLES, COUNTRY_CODE, USER_ROLES } from '../../constants';
import Iconify from '../../components/Iconify';
import { useState } from 'react';
import { FieldConfig, FieldInputProps } from 'formik';
import { NumericFormatCustom } from '../../components/NumericCustomFormatter';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => Promise<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
  getFieldProps: (
    nameOrOptions: string | FieldConfig<any>
  ) => FieldInputProps<any>;
}

const UsersFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
  getFieldProps,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
      key={`uf`}
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>
        {values?.id ? 'Edit User' : 'Create Admin'}
      </DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='name'
                name='name'
                label='Name'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.name}
                error={Boolean(errors.name && touched.name)}
                helperText={Boolean(errors.name && touched.name) && errors.name}
              />
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='lastName'
                name='lastName'
                label='Last name'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.lastName}
                error={Boolean(errors.lastName && touched.lastName)}
                helperText={
                  Boolean(errors.lastName && touched.lastName) &&
                  errors.lastName
                }
              />
            </Grid> */}
            <Grid
              item
              xs={12}
              sm={4}
            >
              <FormControl
                sx={{
                  width: { xs: '100%', sm: '100%' },
                }}
                error={Boolean(
                  touched?.countryCallingCode && errors?.countryCallingCode
                )}
              >
                <InputLabel>{'Code'}</InputLabel>
                <Select
                  name='countryCallingCode'
                  labelId='countryCallingCode'
                  id='countryCallingCode'
                  value={values.countryCallingCode}
                  label={'Code'}
                  onChange={(e) =>
                    setFieldValue('countryCallingCode', e.target.value)
                  }
                  MenuProps={{
                    style: {
                      maxHeight: 400,
                    },
                  }}
                >
                  {COUNTRY_CODE?.map((country) => (
                    <MenuItem
                      key={country.name}
                      value={country.code}
                    >
                      {country.code} {country.name}
                    </MenuItem>
                  ))}
                </Select>
                {Boolean(
                  touched.countryCallingCode && errors.countryCallingCode
                ) && (
                  <FormHelperText>{errors?.countryCallingCode}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
            >
              <TextField
                id='mobileNumber'
                name='mobileNumber'
                label='Mobile Number'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.mobileNumber}
                error={Boolean(errors.mobileNumber && touched.mobileNumber)}
                helperText={
                  Boolean(errors.mobileNumber && touched.mobileNumber) &&
                  errors.mobileNumber
                }
                // disabled={values?.id ? true : false}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='email'
                name='email'
                label={'E-mail'}
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.email}
                error={Boolean(errors.email && touched.email)}
                helperText={
                  Boolean(errors.email && touched.email) && errors.email
                }
                // disabled={values?.id ? true : false}
              />
            </Grid>
            {!values?.id && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <TextField
                  fullWidth
                  autoComplete='current-password'
                  type={showPassword ? 'text' : 'password'}
                  label={'Password'}
                  {...getFieldProps('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          edge='end'
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          <Iconify
                            icon={
                              showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'
                            }
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(touched.password && errors.password)}
                  helperText={
                    Boolean(errors.password && touched.password) &&
                    errors.password
                  }
                  disabled={values?.id ? true : false}
                />
              </Grid>
            )}
            {/* {values?.id && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <FormControl
                  fullWidth
                  // disabled={values?.id ? true : false}
                  error={Boolean(touched.language && errors.language)}
                >
                  <InputLabel>Select Language</InputLabel>
                  <Select
                    id='language'
                    name='language'
                    value={values.language}
                    onChange={(e) => {
                      setFieldValue('language', e.target.value);
                    }}
                    label='Select Language'
                  >
                    {LANGUAGE.map((role) => {
                      return (
                        <MenuItem
                          key={role?.value}
                          value={role?.value}
                          sx={{
                            textTransform: 'capitalize',
                          }}
                        >
                          {role?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {Boolean(touched.language && errors.language) && (
                    <FormHelperText>{errors.language ?? ''}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            )} */}

            {values?.id && values?.userRole !== 'company' && values?.userRole !== 'agent' && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <TextField
                  fullWidth
                  label={'Free Ads'}
                  name='freeAds'
                  id='freeAds'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.freeAds}
                  error={Boolean(errors.freeAds && touched.freeAds)}
                  helperText={
                    Boolean(errors.freeAds && touched.freeAds) &&
                    errors?.freeAds
                  }
                />
              </Grid>
            )}
            {values?.id && values?.userRole !== 'company' && values?.userRole !== 'agent' && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <TextField
                  fullWidth
                  label={'Max Ads'}
                  name='maxAds'
                  id='maxAds'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.maxAds}
                  error={Boolean(errors.maxAds && touched.maxAds)}
                  helperText={
                    Boolean(errors.maxAds && touched.maxAds) && errors?.maxAds
                  }
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControl
                fullWidth
                disabled={values?.id}
                error={Boolean(touched.userRole && errors.userRole)}
              >
                <InputLabel>Select User Role</InputLabel>
                <Select
                  id='userRole'
                  name='userRole'
                  value={values.userRole}
                  onChange={(e) => {
                    setFieldValue('userRole', e.target.value);
                  }}
                  label='Select User Role'
                >
                  {values?.id
                    ? USER_ROLES.map((role) => {
                        return (
                          <MenuItem
                            key={role?.value}
                            value={role?.value}
                            sx={{
                              textTransform: 'capitalize',
                            }}
                          >
                            {role?.name}
                          </MenuItem>
                        );
                      })
                    : ADD_USER_ROLES.map((role) => {
                        return (
                          <MenuItem
                            key={role?.value}
                            value={role?.value}
                            sx={{
                              textTransform: 'capitalize',
                            }}
                          >
                            {role?.name}
                          </MenuItem>
                        );
                      })}
                </Select>
                {Boolean(touched.userRole && errors.userRole) && (
                  <FormHelperText>{errors.userRole ?? ''}</FormHelperText>
                )}
              </FormControl>
            </Grid>

            {values?.id && (
              <Grid
                item
                xs={12}
                sm={12}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      color='primary'
                      name='activeState'
                      onChange={(e) =>
                        setFieldValue('activeState', e.target.checked)
                      }
                      checked={values.activeState}
                    />
                  }
                  label={'Active Status'}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UsersFormModal;
